export default string => {
    let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/

    return format.test(string)
}